<template>
  <div class="mx-auto max-w-3xl space-y-8 pb-4">
    <header>
      <h1 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
        {{ t('landing.how_to_rent.title') }}
      </h1>
    </header>
    <div
      class="space-y-6 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm ring-1 ring-gray-100 sm:p-8"
    >
      <p class="text-gray-700 leading-relaxed">
        {{ t('landing.how_to_rent.step1') }}
      </p>
      <p class="text-gray-700 leading-relaxed">
        {{ t('landing.how_to_rent.step2') }}
      </p>
      <div>
        <h2 class="font-semibold text-gray-900">
          {{ t('landing.how_to_rent.initial_cost_heading') }}
        </h2>
        <p class="mt-2 whitespace-pre-line text-gray-700 leading-relaxed">
          {{ t('landing.how_to_rent.initial_cost_body') }}
        </p>
      </div>
      <div>
        <h2 class="font-semibold text-gray-900">
          {{ t('landing.how_to_rent.revenue_heading') }}
        </h2>
        <p class="mt-2 text-gray-700 leading-relaxed">
          {{ t('landing.how_to_rent.revenue_body') }}
        </p>
      </div>
      <div>
        <h2 class="font-semibold text-gray-900">
          {{ t('landing.how_to_rent.lock_install_heading') }}
        </h2>
        <p class="mt-2 text-gray-700 leading-relaxed">
          {{ t('landing.how_to_rent.lock_install_lead') }}
          <NuxtLink
            :to="localePath('/install-lock')"
            class="font-medium text-primary-600 underline decoration-primary-300 underline-offset-2 hover:text-primary-800"
          >
            {{ t('landing.how_to_rent.lock_install_cta') }}
          </NuxtLink>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
const localePath = useLocalePath()

useHead(() => ({
  title: t('landing.how_to_rent.meta_title'),
  meta: [{ name: 'description', content: t('landing.how_to_rent.meta_description') }],
}))
</script>
